/**
 * Choose a column count that balances the buttons across rows, capping at
 * `maxPerRow`. Examples (maxPerRow = 4): 3->3, 4->4, 5->3 (3+2), 6->3 (3+3),
 * 7->4 (4+3), 8->4 (4+4), 9->3 (3+3+3). Keeps rows even instead of leaving a
 * single stranded button.
 */
export function balancedColumns(count, maxPerRow = 4) {
    if (count <= 1) {
        return 1;
    }
    const cap = Math.max(1, maxPerRow);
    const perRow = Math.min(count, cap);
    const rows = Math.ceil(count / perRow);
    return Math.ceil(count / rows);
}
/** The active preset list for a frequency (all 3 keys are always present on the map). */
export function resolveActivePresets(presetsByFrequency, freq) {
    return presetsByFrequency[freq];
}
